import { createContext, FC, useContext, useState } from 'react';

import { IPropsWithChildrenAndClassName, Noop } from 'types/common.interface';

import CircleSpinner from '../circleSpinner/CircleSpinner';
import './ElementLoader.scss';

export interface IElementLoaderContext {
  enableUi: Noop;
  disableUi: Noop;
}

export const ElementLoaderContext = createContext<IElementLoaderContext>({
  enableUi: () => {},
  disableUi: () => {},
});

export const useElementLoaderContext = () => useContext(ElementLoaderContext);

interface IElementLoader extends IPropsWithChildrenAndClassName {
  loading?: boolean;
}

const ElementLoader: FC<IElementLoader> = ({ loading, children, className = '' }) => {
  const [disableUi, setDisableUi] = useState(true);
  const classes = `element-loader ${loading ?? disableUi ? 'disable-ui' : ''} ${className}`;

  return (
    <ElementLoaderContext.Provider
      value={{
        enableUi: () => setDisableUi(false),
        disableUi: () => setDisableUi(true),
      }}
    >
      <span className={classes}>
        <CircleSpinner size={48} />
      </span>
      {children}
    </ElementLoaderContext.Provider>
  );
};

export default ElementLoader;
